<template>
	<v-snackbar v-model="isActive" timeout="3000" :color="color" transition="slide-y-reverse-transition" :content-class="alertClass">
		{{text}}
      <template v-slot:action="{ attrs }">
        <v-btn :fab="true" v-bind="attrs" @click="resetHttpResponse" :color="setColor">
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </template>
	</v-snackbar>
</template>

<script>
export default {
  name: 'HTTPResponse',
  props: {
    text: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    isActive: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    alertClass () {
      switch (this.color) {
        case 'error':
          return 'alert-error'
        case 'warning':
          return 'warning'
        default:
          return ''
      }
    },
    setColor () {
      const vm = this
      if (vm.color === 'success') return 'success'
      else return 'error'
    }
  }
}
</script>

<style scoped>
::v-deep .warning {
	color: #856404 !important;
}

.v-btn--fab.v-size--default {
	height: 26px;
	width: 26px;
	box-shadow: none !important;
}

.v-btn--fab.v-size--default .v-icon {
	font-size: 15px;
}
</style>
